import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { formatDate } from 'Utils/Dates'
import { paymentSetData } from 'Checkout/Redux/Actions/Payment'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import { useStayDates } from 'Checkout/Hooks/useStayDates'
import { withSkeleton } from 'Shared/Skeleton/withSkeleton'
import ExtraPricingFields from 'Checkout/Components/ReservationDetails/ReservationTotal/ExtraPricingFields'
import ReservationDetailItem from 'Shared/ReservationDetailItem'

const ReservationTotal = () => {
  const { checkIn, checkOut } = useStayDates()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const pricing = useSelector(state => state.cart.pricing.data)
  const isPricingLoading = useSelector(state => state.cart.pricing.loading)
  const errorPrice = useSelector(state => state.cart.pricing.error)
  const expandedPricing = [routesHandler.cart.path, routesHandler.payment.path].includes(location.pathname)

  useEffect(() => {
    const message = errorPrice?.graphQLErrors[0].message
    const regex = new RegExp('NBT Errors')

    if (regex.test(message))
      history.push(`/search?check_in=${formatDate(checkIn)}&check_out=${formatDate(checkOut)}`)
  }, [errorPrice])

  useEffect(() => {
    if (!isPricingLoading) dispatch(paymentSetData(pricing))
  }, [isPricingLoading])

  if (!pricing?.subtotal?.amount) return null

  return (
    <div className="reservation-details--total text-gray">
      <ReservationDetailItem hideColon itemName="Subtotal" itemNameClass="fw-normal not-all-block-loading"
                             value={pricing?.subtotal?.display} />

      {expandedPricing && <ExtraPricingFields />}
    </div>
  )
}

export default withSkeleton(ReservationTotal, state => state.cart.pricing)
